import React, { RefObject } from 'react'
import { Box, Color } from '@gousto-internal/citrus-react'
import { Hero, TrustPilot, PeekInTheBox, LovedBy } from '../components'
import { ValueForMoney } from '../components/ValueForMoney/ValueForMoney'
import { useFetchRafCampaignDetails } from '../hooks/useFetchRafCampaignDetails'
import { PromoBanner } from '../components/PromoBanner'

export type RafLandingPageType = {
  useIsOptimizelyFeatureEnabled: (name: string | null) => boolean | null
  onScrollHandler: ({
    heroRef,
    stickyCTARef,
    setIsSticky,
    setMaxHeight,
  }: {
    heroRef: RefObject<HTMLDivElement>
    stickyCTARef: RefObject<HTMLDivElement>
    setIsSticky: (isSticky: boolean) => void
    setMaxHeight: (isSticky: number) => void
  }) => void
}

export type RafFloatingCtaAndDiscountBannerType = {
  isFloatingCtaAndDiscountBannerEnabled: boolean | null
}

export const RafLandingPage = ({
  useIsOptimizelyFeatureEnabled,
  onScrollHandler,
}: RafLandingPageType) => {
  const { firstBoxDiscount, secondBoxDiscount, giftYourFriendCredit } = useFetchRafCampaignDetails()

  const isFloatingCtaAndDiscountBannerEnabled = useIsOptimizelyFeatureEnabled(
    'beetroots_raf_floating_cta_and_discount_banner',
  )

  return (
    <Box paddingBottom={[10, 6]} bg={Color.White}>
      {isFloatingCtaAndDiscountBannerEnabled && (
        <PromoBanner firstBoxDiscount={firstBoxDiscount} secondBoxDiscount={secondBoxDiscount} />
      )}
      <Hero
        firstBoxDiscount={firstBoxDiscount}
        secondBoxDiscount={secondBoxDiscount}
        giftYourFriendCredit={giftYourFriendCredit}
        onScrollHandler={onScrollHandler}
        isFloatingCtaAndDiscountBannerEnabled={isFloatingCtaAndDiscountBannerEnabled}
      />
      <LovedBy />
      <ValueForMoney
        isFloatingCtaAndDiscountBannerEnabled={isFloatingCtaAndDiscountBannerEnabled}
      />
      <TrustPilot />
      <PeekInTheBox isFloatingCtaAndDiscountBannerEnabled={isFloatingCtaAndDiscountBannerEnabled} />
    </Box>
  )
}
